import React from 'react';
import { Check } from 'lucide-react';
import ShopThemed, { THEMES } from '../../../themes';

export const ThemePickerPanel = ({ form, onChange, barbers, pickerServices, pickerHours }) => (
  <div className="panel" style={{ padding: 18, marginBottom: 14 }}>
    <label style={{ fontSize: 12.5, fontWeight: 600, display: 'block', marginBottom: 4 }}>
      Shop-front theme
      <span className="hint"> — visual style of your public booking page</span>
    </label>
    <div className="theme-picker" data-testid="theme-picker" role="radiogroup" aria-label="Shop-front theme">
      {THEMES.map(t => {
        const isSelected = form.theme === t.slug;
        const isLocked = t.locked === true;
        // Locked themes are unclickable and unfocusable. `pick`
        // is a no-op so no selection state / preview / nav can
        // happen. Flip `locked: false` in themes/index.js to
        // re-enable a single theme once it's ready.
        const pick = () => { if (!isLocked) onChange({ theme: t.slug }); };
        return (
          <div
            key={t.slug}
            className={`tcard ${isSelected ? 'selected' : ''} ${isLocked ? 'locked' : ''}`}
            onClick={pick}
            onKeyDown={(e) => { if (!isLocked && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pick(); } }}
            data-testid={`theme-card-${t.slug}`}
            role="radio"
            tabIndex={isLocked ? -1 : 0}
            aria-checked={isSelected}
            aria-disabled={isLocked || undefined}
            title={isLocked ? `${t.label} — coming soon` : t.label}
          >
            <div className="scl">
              <ShopThemed
                theme={t.slug}
                shop={{
                  name: form.name || 'Your shop',
                  tagline: form.tagline,
                  welcome_text: form.welcome_text,
                  address: form.address,
                  logo_url: form.logo_url,
                  accent_colour: form.accent_colour,
                  gallery_urls: form.gallery_urls,
                  hero_image_url: form.hero_image_url,
                  hero_opacity: form.hero_opacity,
                  reviews: form.reviews,
                  deposit_required: form.deposit_required,
                  deposit_amount: form.deposit_amount,
                  social_links: form.social_links || {},
                  theme: t.slug,
                }}
                services={pickerServices}
                barbers={barbers}
                hours={pickerHours}
                onBook={() => {}}
              />
            </div>
            {isSelected && !isLocked && (
              <span className="check" aria-hidden="true">
                <Check size={13} strokeWidth={3} />
              </span>
            )}
            {isLocked && (
              <span className="coming-soon" aria-hidden="true">Coming soon</span>
            )}
            <span className="label">
              {t.label}
              {t.isDefault && <em className="default-tag">Default</em>}
            </span>
          </div>
        );
      })}
    </div>
  </div>
);
